"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryScreening = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var PrimaryScreening = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PrimaryScreening, _super);
    function PrimaryScreening() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷授信初筛接口';
        _this.code = '101120';
        _this.desc = '现金贷授信初筛接口';
        _this.requestParams = new cashLoanAuth_1.PrimaryScreeningRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PrimaryScreening;
}(service_1.BaseService));
exports.PrimaryScreening = PrimaryScreening;
//# sourceMappingURL=primaryScreening.js.map